module.exports = __webpack_public_path__ + "media/gb.4f1b7af5.svg";